import { AbstractControl, ValidationErrors } from '@angular/forms';
import { isNilOrEmpty } from 'helpers';
import parsePhoneNumber from 'libphonenumber-js-custom'

export function e164PhoneValidator(control: AbstractControl): ValidationErrors | null {
  if (isNilOrEmpty(control.value) || control.value.length < 1) {
    return null;
  }
  try {
    if (parsePhoneNumber(control.value).isValid()) {
      return null;
    }
  } catch (err: any) { }

  return { phone: 'Invalid Phone Number' };
}

